module.exports = __webpack_public_path__ + "img/goods2_4.e1624f8c.jpg";